import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { loadTechStackSuccess, loadTechStackFailure, updateTechStack } from './tech-stack.actions';

export interface TechStack {
  id: string;
}

export interface TechStackState extends EntityState<TechStack> {
  loading: boolean;
  error: any;
}

export const techStackAdapter: EntityAdapter<TechStack> = createEntityAdapter<TechStack>();

export const initialState: TechStackState = techStackAdapter.getInitialState({
  loading: false,
  error: null
});

export const techStackReducer = createReducer(
  initialState,
  on(loadTechStackSuccess, (state, { techStack }) => techStackAdapter.upsertOne(techStack, { ...state, loading: false })),
  on(loadTechStackFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(updateTechStack, (state, { techStack }) => techStackAdapter.updateOne({ id: techStack.id, changes: techStack }, state))
);

export const {
  selectAll: selectAllTechStacks,
  selectEntities: selectTechStackEntities,
  selectIds: selectTechStackIds,
  selectTotal: selectTotalTechStacks
} = techStackAdapter.getSelectors();
